module.exports = __webpack_public_path__ + "img/BlinkArt_Mace1H_Medium.f338b2a3.png";